/** @module csi/widget/Barcode */
define([
	"jsbarcode"
], function (JsBarcode) {

	/**
	 * Wrapper module for jsbarcode library - https://github.com/lindell/JsBarcode
	 */

	return {
		/**
		 * Return true if given options use a supported barcode format
		 * @param {Object} options - reference https://github.com/lindell/JsBarcode for available options
		 */
		isValidFormat: function (options) {
			return !!JsBarcode.getModule(options.format);
		},

		/**
		 * Return true if given value is a valid barcode for given options
		 * @param {string} value
		 * @param {Object} options - reference https://github.com/lindell/JsBarcode for available options
		 */
		isValidValue: function (value, options) {
			var module = JsBarcode.getModule(options.format);
			var encoder = new module(value, options);
			return encoder.valid();
		},

		/**
		 * Render barcode
		 * @param {DomNode} domNode - node where to render barcode
		 * @param {string} value
		 * @param {Object} options - reference https://github.com/lindell/JsBarcode for available options
		 */
		render: function (domNode, value, options) {
			var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
			JsBarcode(svg, value, options);
			domNode.appendChild(svg);
		}
	};
});
